import { rgba, typography } from '../core/utils';

import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';

export const Alert = styled.div<{
   variant?: 'info' | 'warning' | 'error' | 'success';
}>`
   ${typography.bodyS}
   display: flex;
   align-items: flex-start;
   gap: ${tokens.space.sm};
   padding: ${tokens.space.sm} ${tokens.space.md};
   border-radius: ${tokens.radius.md};
   margin-bottom: ${tokens.space.md};

   ${({ variant = 'info' }) => {
      const colors = {
         info: theme.colors.state.info,
         warning: theme.colors.state.warning,
         error: theme.colors.state.error,
         success: theme.colors.state.success,
      };
      const color = colors[variant];

      return css`
         background-color: ${rgba(color, 0.1)};
         border: ${variant === 'error' ? tokens.border.thick : tokens.border.thin} ${color};
         color: ${theme.colors.text.primary};
      `;
   }}

   svg {
      width: 1.25rem;
      height: 1.25rem;
      flex-shrink: 0;
   }
`;

export const Badge = styled.span<{
   variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
}>`
   display: inline-block;
   padding: 2px ${tokens.space.xs};
   font-size: ${tokens.font.size.sm};
   font-weight: ${tokens.font.weight.semibold};
   border-radius: ${tokens.radius.md};

   ${({ variant = 'default' }) => {
      if (variant === 'default') {
         return css`
            background-color: ${theme.colors.bg.secondary};
            color: ${theme.colors.text.secondary};
         `;
      }
      const color = theme.colors.state[variant as keyof typeof theme.colors.state];
      return css`
         background-color: ${rgba(color, 0.15)};
         color: ${color};
      `;
   }}
`;

export const InlineLoadingText = styled.span`
   color: ${theme.colors.text.tertiary};
   font-size: ${tokens.font.size.sm};
`;

export const LoadingState = styled.div`
   padding: ${tokens.space.sm} ${tokens.space.md};
   color: ${theme.colors.text.tertiary};
`;

export const ErrorMessage = styled.div`
   font-size: ${tokens.font.size.sm};
   margin-bottom: ${tokens.space.sm};
   color: ${theme.colors.state.error};
`;

export const ErrorContainer = styled.div`
   padding: ${tokens.space.md};
   background-color: ${rgba(theme.colors.state.error, 0.1)};
   border-left: 3px solid ${theme.colors.state.error};
   margin: ${tokens.space.md} 0;
   border-radius: ${tokens.radius.md};
`;
